import { connect } from 'react-redux';
import fp from 'lodash/fp';
import {
  getClientColumnsByName,
  getIsFetchingClientColumns
} from '../../../../../redux/selectors/client';
import {
  getVisitColumnsByName,
  getIsFetchingVisitColumns
} from '../../../../../redux/selectors/visit/columns';

import { updateOutreachAggregateReportQuery } from '../../../../../redux/actions/report';
import { getOutreachAggregateReportQuery } from '../../../../../redux/selectors/report/outreach-aggregate';
import { getIsSaving } from '../../../../../redux/selectors/download-request';
import { fetchClientColumns } from '../../../../../redux/sagas/client/routines';
import {
  fetchVisitColumns,
  createDownloadRequest
} from '../../../../../redux/sagas/routines';
import { fetchOutreachAggregateOptions } from '../../../../../redux/sagas/report/routines';
import OutreachAggregateReport from './component';
import {
  getOutreachAggregateLocationOptions,
  getSortedOutreachAggregateTrackingMethodOptions as getTrackingMethodOptions
} from '../../../../../redux/selectors/report/outreach-aggregate/options';
import {
  composeGroupByOptions,
  composeSumOrCountByOptions
} from '../../../../../containers/OutreachAggregateView/helpers/columnsToOptions';
import { Context } from '../../../../../constants/download-request';

function mapStateToProps(state) {
  const locationOptions = getOutreachAggregateLocationOptions(state);
  const trackingMethodOptions = getTrackingMethodOptions(state);
  const clientColumnsByName = getClientColumnsByName(state);
  const visitColumnsByName = getVisitColumnsByName(state);
  const clientColumns = fp.flow(
    fp.values,
    fp.sortBy('label')
  )(clientColumnsByName);
  const visitColumns = fp.flow(
    fp.values,
    fp.sortBy('label')
  )(visitColumnsByName);
  const groupByOptions = composeGroupByOptions(clientColumns, visitColumns);
  const sumOrCountByOptions = composeSumOrCountByOptions(
    clientColumns,
    visitColumns
  );

  const query = getOutreachAggregateReportQuery(state);

  return {
    ...state,
    groupByOptions,
    sumOrCountByOptions,
    locationOptions,
    trackingMethodOptions,
    searchQuery: query,
    isFetchingColumns:
      getIsFetchingClientColumns(state) || getIsFetchingVisitColumns(state),
    isSaving: getIsSaving(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: () => {
      dispatch(fetchClientColumns());
      dispatch(fetchVisitColumns());
      dispatch(fetchOutreachAggregateOptions());
    },

    onSubmit: ({ name, dateRange, ...restFormValues }) => {
      const format = 'YYYY-MM-DD';
      const formattedDateRange = fp.map(each => each.format(format), dateRange);
      const noValue = prop => (fp.isArray(prop) && fp.isEmpty(prop)) || !prop;
      const query = fp.flow(
        fp.set('dateRange', formattedDateRange),
        fp.omitBy(noValue)
      )(restFormValues);

      const body = { context: Context.OUTREACH_AGGREGATE_REPORT, name, query };
      dispatch(updateOutreachAggregateReportQuery(body));
      dispatch(createDownloadRequest(body));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OutreachAggregateReport);
